import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, map } from 'rxjs';

import { Table, TableRow } from './types';

export class TableDataSource extends DataSource<TableRow> {
  private readonly data: Observable<TableRow[]>;
  private readonly table$: BehaviorSubject<Table>;

  constructor(initialTable: Table) {
    super();
    this.table$ = new BehaviorSubject(initialTable);
    this.data = this.table$.pipe(map(table => table?.rows ?? []));
  }

  public next(table: Table): void {
    this.table$.next(table);
  }

  public override connect(): Observable<TableRow[]> {
    return this.data;
  }

  public override disconnect(): void {
    return;
  }
}
